var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMarkCircleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 9.99935C1.66602 5.40018 5.39935 1.66602 9.99935 1.66602C14.6077 1.66602 18.3327 5.40018 18.3327 9.99935C18.3327 14.6002 14.6077 18.3327 9.99935 18.3327C5.39935 18.3327 1.66602 14.6002 1.66602 9.99935ZM9.26602 6.84102C9.26602 6.44185 9.59935 6.10768 9.99935 6.10768C10.3993 6.10768 10.7243 6.44185 10.7243 6.84102V10.5243C10.7243 10.9252 10.3993 11.2493 9.99935 11.2493C9.59935 11.2493 9.26602 10.9252 9.26602 10.5243V6.84102ZM10.0077 13.9002C9.59935 13.9002 9.27435 13.5668 9.27435 13.1668C9.27435 12.7668 9.59935 12.4418 9.99935 12.4418C10.4077 12.4418 10.7327 12.7668 10.7327 13.1668C10.7327 13.5668 10.4077 13.9002 10.0077 13.9002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCircleWhite);
export default __webpack_public_path__ + "static/media/exclamation-mark-circle--white.57d1a3c65a4d3fdd8f0e4d88e5d5e7ed.svg";
export { ForwardRef as ReactComponent };